import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ReactComponent as MenuStar } from "../../components/imgComponents/menu-star.svg";
import "../../css/header.scss";

const Header = (props) => {
  const [scroll, setScroll] = useState(0);
  const [headerClass, setHeaderClass] = useState("");
  const ProgressBar = () => (
    <span className="progressBar">
      <span className="fill" style={{ width: scroll + `%` }}></span>
    </span>
  );

  const navigate = useNavigate();

  const handleClick = (e, href, title) => {
    e.preventDefault();
    let color = "";
    switch (href) {
      case "/":
        color = "#262626";
        break;
      case "/before":
        color = "#ffb297";
        break;
      case "/during":
        color = "#B4A8F6";
        break;
      case "/after":
        color = "#57c0a9";
        break;
      default:
        color = "#262626";
        break;
    }

    if (typeof window.redcross !== "undefined") {
      const obj = {
        btnText: title,
        btnContext: href,
        btnName: title,
        btnLocation: `BFCM Header navigation`,
      };
      window.redcross.track("Button Clicked", obj, {}, function () {
        props.handlePageRoute(color);
        setTimeout(() => {
          navigate(href);
        }, 500);
      });
    } else {
      props.handlePageRoute(color);
      setTimeout(() => {
        navigate(href);
      }, 500);
    }
  };

  const DesktopMenu = () => (
    <>
      <NavLink to="/" onClick={(e) => handleClick(e, "/", "Home")}>
        Home
        <ProgressBar />
      </NavLink>
      <NavLink to="/before" onClick={(e) => handleClick(e, "/before", "Before BFCM")}>
        <MenuStar />
        <div>
          Before BFCM <span className="date">{props.before_page_dates}</span>
        </div>
        <ProgressBar />
      </NavLink>
      <NavLink to="/during" onClick={(e) => handleClick(e, "/during", "During BFCM")}>
        <MenuStar />
        <div>
          During BFCM <span className="date">{props.during_page_dates}</span>
        </div>
        <ProgressBar />
      </NavLink>
      <NavLink to="/after" onClick={(e) => handleClick(e, "/after", "After BFCM")}>
        <MenuStar />
        <div>
          After BFCM <span className="date">{props.after_page_dates}</span>
        </div>
        <ProgressBar />
      </NavLink>
    </>
  );

  useEffect(() => {
    let progressBarHandler = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll = `${totalScroll / windowHeight}`;
      setScroll(Math.floor(scroll * 100));
    };
    window.addEventListener("scroll", progressBarHandler);
    return () => window.removeEventListener("scroll", progressBarHandler);
  });

  useEffect(() => {
    let location = window.location.href.split("/").pop();

    if (location.indexOf("during") > -1) {
      location = "during";
    } else if (location.indexOf("after") > -1) {
      location = "after";
    } else if (location.indexOf("before") > -1) {
      location = "before";
    } else if (location.indexOf("lp") > -1) {
      location = "lp";
    } else {
      location = "home";
    }
    setHeaderClass(location);
  }, []);

  const handleClassName = (e) => {
    const link = e.target.href.split("/");
    let location = link[link.length - 1];
    if (location === "") {
      location = "home";
    }
    setHeaderClass(location);
  };

  return (
    <nav
      id="bfcm-header"
      className={(typeof window.isLocalhost !== "undefined" ? "header-production" : "") + " " + headerClass}
      onClick={(e) => {
        e.preventDefault();
        handleClassName(e);
      }}
    >
      <DesktopMenu />
    </nav>
  );
};

export default Header;
